export function genesisUUID(): string {
  /*
   * randomUUID is preferred when available.
   * It may be unavailable in non-secure HTTP preview contexts.
   */
  if (
    typeof crypto !== 'undefined' &&
    typeof crypto.randomUUID === 'function'
  ) {
    return crypto.randomUUID()
  }

  /*
   * Cryptographically stronger fallback when getRandomValues exists.
   */
  if (
    typeof crypto !== 'undefined' &&
    typeof crypto.getRandomValues === 'function'
  ) {
    const bytes = new Uint8Array(16)

    crypto.getRandomValues(bytes)

    bytes[6] =
      (bytes[6] & 0x0f) | 0x40

    bytes[8] =
      (bytes[8] & 0x3f) | 0x80

    const hex = Array.from(
      bytes,
      byte =>
        byte
          .toString(16)
          .padStart(2, '0'),
    )

    return [
      hex.slice(0, 4).join(''),
      hex.slice(4, 6).join(''),
      hex.slice(6, 8).join(''),
      hex.slice(8, 10).join(''),
      hex.slice(10, 16).join(''),
    ].join('-')
  }

  /*
   * Last-resort UI/session identifier.
   * Production will normally use HTTPS + randomUUID.
   */
  return [
    Date.now().toString(16),
    Math.random().toString(16).slice(2),
    Math.random().toString(16).slice(2),
  ].join('-')
}
